import request from '@/service';

// get 请求
export function getDepartmentList(params) {
  return request({
    url: '/web/department/getDepartmentList',
    method: 'get',
    params
  })
}

// post 请求
// export function getDepartmentList (data) {
//   return request({
//     method: 'post',
//     data
//   })
// }

export function getBannerList(params) {
  params = params || {};
  params.sign = 0
  params.appId = 0
  return request({
    url: "/ft/banner/list",
    method: "get",
    params
  });
}
